<div mat-dialog-title class="flex flex-row">
    Confirmar Dados
    <div class="flex-fill"></div>
</div>
<div mat-dialog-content>
    <br>
    <div class="flex">
        <table>
            <thead>
                <tr>
                    <th class="th-bordered descricao">Nome Completo:</th>
                    <th class="th-bordered">{{this.aluno?.nome}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Data de Nascimento:</th>
                    <th class="th-bordered">{{this.dataNascimento}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Estado Civil:</th>
                    <th class="th-bordered">{{this.estadoCivil}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Sexo:</th>
                    <th class="th-bordered">{{this.sexo}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">R.G.:</th>
                    <th class="th-bordered">{{this.aluno?.rg}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Órgão Expeditor:</th>
                    <th class="th-bordered">{{this.aluno?.orgaoExpedicao}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">CPF:</th>
                    <th class="th-bordered">{{this.cpfFormatado}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Titulo Eleitoral:</th>
                    <th class="th-bordered">{{this.aluno?.tituloEleitoral}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Zona:</th>
                    <th class="th-bordered">{{this.aluno?.zona}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Seção:</th>
                    <th class="th-bordered">{{this.aluno?.secao}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Nacionalidade:</th>
                    <th class="th-bordered">{{this.aluno?.nacionalidade?.descricao}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Naturalidade:</th>
                    <th class="th-bordered">{{this.aluno?.naturalidade?.descricao}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Nome da Mãe:</th>
                    <th class="th-bordered">{{this.aluno?.nomeMae}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Nome do Responsável:</th>
                    <th class="th-bordered">{{this.aluno?.nomeResponsavel}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Endereço:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.rua}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Número:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.numero}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Complemento:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.complemento}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Bairro:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.bairro}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">Cidade:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.cidade}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">UF:</th>
                    <th class="th-bordered">{{this.aluno?.endereco?.estado}}</th>
                </tr>
                <tr>
                    <th class="th-bordered descricao">CEP:</th>
                    <th class="th-bordered">{{this.cepFormatado}}</th>
                </tr>
            </thead>
        </table>
    </div>
    <br>
    <div class="flex">
            <div>
                <button mat-button color="primary" (click)="editarDados()" type="button">Editar Dados</button>
            </div>
            <div class="flex-fill"></div>
            <div>
                <button mat-raised-button color="primary" type="button" (click)="salvarData()" cdkFocusInitial>Confirmar Dados</button>
        </div>
    </div>
</div>
